import { type FilterDict } from "../types/filter";
import { Role, type Department } from "../types/user";
import { QuestionTypeArray, QuestionStatusArray } from "../types/qna";
import { translator } from "../utils/translator";

export const getQnaFilterDict = (
  department: Department[],
  role: Role
): FilterDict => ({
  "": {
    type: "default",
    label: "선택",
  },
  type: {
    type: "select",
    label: "구분",
    options: [
      { value: "", label: "전체" },
      ...QuestionTypeArray.map((type) => ({
        value: type,
        label: translator[type],
      })),
    ],
  },
  status: {
    type: "select",
    label: "상태",
    options: [
      { value: "", label: "전체" },
      ...QuestionStatusArray.map((type) => ({
        value: type,
        label: translator[type],
      })),
    ],
  },
  department: {
    type: "select",
    label: "담당부서",
    options: [
      { value: "", label: "전체" },
      { value: JSON.stringify(["life", "pro"]), label: "행정실" },
      ...[
        { value: JSON.stringify(["life"]), label: "생활스포츠" },
        { value: JSON.stringify(["pro"]), label: "전문스포츠" },
      ].filter((option) => department.includes(JSON.parse(option.value)[0])),
    ],
    disabled: role === "staff" && department.length === 1,
    defaultValue: department[0],
  },
  content__contains: {
    type: "input",
    label: "내용",
  },
});
